<template>
    <img @click="startSound()" :src="require('@/assets/images/custom-sound-box.jpeg')" />
</template>
<script>
export default {
    name : 'ShowSoundBox',
    props : {
        sound_box : {
            type : Object
        }
    },
    methods : {
        startSound(){
            if(this.sound_box?.type === "TTS"){
                this.$common.readQuestionLoud(this.sound_box.text_input)
            }
        }
    }
}
</script>